"use strict";

var curryN = require('../function/curryN');
/**
 * Determines whether a given string matches a given regular expression.
 *
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 */
module.exports = curryN(2, function (pattern, str) {
  if (pattern === void 0) {
    pattern = /()/;
  }
  if (str === void 0) {
    str = '';
  }
  return pattern.test(str);
});